import posthtml from 'posthtml/lib';
export const addInfoComponents = (options, t) => {
  const siteUrl = options.siteUrl,
    unsubscribeUrl = options.unsubscribeUrl;
  let components = [];
  const link = url => ({
    tag: 'u',
    content: [{
      tag: 'a',
      attrs: {
        'css-class': 'info-section-link',
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        style: 'font-family: Helvetica,Ubuntu,Arial,sans-serif; color: #222222; font-size:12px; line-height: 20px; text-decoration: none;'
      },
      content: []
    }]
  });
  if (siteUrl && unsubscribeUrl) {
    components = [...components, textComponent(transcludeContent(t('EMAIL.USER.THIS_SITE_NEW'), [link(siteUrl)]))];
  }
  if (siteUrl && !unsubscribeUrl) {
    components = [...components, textComponent(transcludeContent(t('EMAIL.USER.THIS_SITE_SINGLE'), [link(siteUrl)]))];
  }
  if (!siteUrl && unsubscribeUrl) {
    components = [...components, textComponent(transcludeContent(t('EMAIL.USER.UNSUBSCRIBE_SINGLE'), [link(unsubscribeUrl)]))];
  }
  if (siteUrl && unsubscribeUrl) {
    components = [...components, textComponent(transcludeContent(t('EMAIL.USER.UNSUBSCRIBE_NEW'), [link(unsubscribeUrl)]))];
  }
  return components;
};
const textComponent = content => ({
  tag: 'mj-text',
  attrs: {
    align: 'center',
    color: '#757575',
    'font-family': 'Helvetica,Ubuntu,Arial,sans-serif',
    'font-size': '12px',
    padding: '0px',
    'line-height': '20px'
  },
  content
});
function transcludeContent(text, components) {
  const usedTagIndicesInText = (text.match(/(?<=<)\d*?(?=>)/giu) ?? []).map(digit => Number(digit)).sort();
  const numberOfUsedComponents = usedTagIndicesInText.length < components.length ? usedTagIndicesInText.length : components.length;
  const indexToComponentMapping = Array.from({
    length: numberOfUsedComponents
  }).map((_, i) => i).reduce((mapping, index) => {
    return {
      ...mapping,
      [usedTagIndicesInText[index]]: components[index]
    };
  }, {});
  const transclude = tree => {
    tree.walk(node => {
      if (typeof node !== 'string' && /\d/.test(node.tag)) {
        let newNode = indexToComponentMapping[node.tag];
        newNode = setLeafContent(newNode, node.content);
        return newNode;
      }
      return node;
    });
  };
  const trans = posthtml([transclude]).process(text, {
    sync: true,
    xmlMode: true
  });
  return trans.tree.map(_ => _);
}
const setLeafContent = (node, content) => {
  const childNode = node.content.find(item => (item || {}).content);
  if (childNode) {
    node.content = setLeafContent(childNode, content);
  } else {
    node.content = content;
  }
  return node;
};
//# sourceMappingURL=utils.js.map